import { render, staticRenderFns } from "./landingpages.vue?vue&type=template&id=3f9cfd36&"
import script from "./landingpages.vue?vue&type=script&lang=js&"
export * from "./landingpages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports